import React from 'react';
import { createRoot } from 'react-dom/client';
import Workspace from './components/Workspace';
import './style.css';
import config from './config/config.json';

const gaId = (config as { enabledModules?: { general?: { googleAnalytics?: { ID?: string } } } }).enabledModules?.general?.googleAnalytics?.ID;
if (gaId) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag = function() { (window as any).dataLayer.push(arguments); };
  (window as any).gtag('js', new Date());
  (window as any).gtag('config', gaId);
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);
}

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Workspace />
    </React.StrictMode>
  );
}
